import {
  AlertTooltip,
  boldBodyTypography,
  Typography,
} from '@leaftrade/leaftrade-component-library';
import React, { useState } from 'react';
import { useStorefrontState } from '../../../hooks/useReduxState';
import {
  CheckoutPaymentBlock,
  CheckoutPaymentInlineInfo,
} from './CheckoutPaymentInfo.styles';
import {
  getPaymentMethodTooltip,
  getPaymentTermsTooltip,
  getTermsBasisTooltip,
} from './utils';

const CheckoutPaymentInfo = () => {
  const { checkout } = useStorefrontState();
  const { basisDateDisplay, paymentMethodDisplay, paymentTermsDisplay } =
    checkout.checkoutData;
  const [paymentTermsOpen, setPaymentTermsOpen] = useState(false);
  const [termsBasisOpen, setTermsBasisOpen] = useState(false);
  const [paymentMethodOpen, setPaymentMethodOpen] = useState(false);
  const paymentTermsTooltip = getPaymentTermsTooltip(
    paymentTermsDisplay,
    basisDateDisplay
  );
  const termsBasisTooltip = getTermsBasisTooltip(basisDateDisplay);
  const paymentMethodTooltip = getPaymentMethodTooltip(paymentMethodDisplay);

  if (!paymentMethodDisplay) {
    return null;
  }

  return (
    <CheckoutPaymentBlock data-testid='checkout-payment-info--component--div'>
      <CheckoutPaymentInlineInfo>
        <Typography bodyStyle={boldBodyTypography}>Payment Terms:</Typography>{' '}
        <Typography>
          {paymentTermsDisplay || 'Not specified for this shipping location'}
        </Typography>
        {paymentTermsDisplay ? (
          <AlertTooltip
            alertType='info'
            id='checkout-payment-terms-tooltip'
            isOpen={paymentTermsOpen}
            setIsOpen={setPaymentTermsOpen}
            tooltipPlacement='right'
          >
            {paymentTermsTooltip}
          </AlertTooltip>
        ) : null}
      </CheckoutPaymentInlineInfo>
      {basisDateDisplay ? (
        <CheckoutPaymentInlineInfo>
          <Typography bodyStyle={boldBodyTypography}>
            Payment terms start:
          </Typography>{' '}
          <Typography>{basisDateDisplay}</Typography>
          <AlertTooltip
            alertType='info'
            id='checkout-payment-terms-basis-tooltip'
            isOpen={termsBasisOpen}
            setIsOpen={setTermsBasisOpen}
            tooltipPlacement='right'
          >
            {termsBasisTooltip}
          </AlertTooltip>
        </CheckoutPaymentInlineInfo>
      ) : null}
      <CheckoutPaymentInlineInfo>
        <Typography bodyStyle={boldBodyTypography}>Payment Method:</Typography>{' '}
        <Typography>{paymentMethodDisplay}</Typography>
        <AlertTooltip
          alertType='info'
          id='checkout-payment-method-tooltip'
          isOpen={paymentMethodOpen}
          setIsOpen={setPaymentMethodOpen}
          tooltipPlacement='right'
        >
          {paymentMethodTooltip}
        </AlertTooltip>
      </CheckoutPaymentInlineInfo>
    </CheckoutPaymentBlock>
  );
};

export default CheckoutPaymentInfo;
